import CircularProgress from '../CircularProgress';
import Typography from '../Typography';

export function CarregandoDadosSistema() {
  return (
    <div className="flex flex-col gap-4 items-center justify-center">
      <Typography component="h4">Aguarde enquanto configuramos nosso sistema</Typography>
      <CircularProgress component="grande" />
    </div>
  );
}
